import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { alpha } from '@material-ui/core/styles/colorManipulator';
import { makeStyles } from '@material-ui/core/styles';
export default makeStyles(function (theme) {
  return {
    root: {
      color: theme.palette.denim[500],
      fontFamily: theme.typography.fontFamilyRegular
    },
    head: {
      borderBottomWidth: 2,
      borderBottomColor: theme.palette.denim[500],
      fontSize: theme.typography.pxToRem(14),
      fontFamily: theme.typography.fontFamilyMedium,
      height: 40,
      lineHeight: 1,
      paddingTop: 0,
      paddingBottom: 0,
      '&:hover': {
        background: function (props) {
          return props.sortable ? alpha(theme.palette.denim[500], 0.05) : 'inherit';
        }
      },
      '&:active': {
        background: function (props) {
          return props.sortable ? alpha(theme.palette.denim[500], 0.1) : 'inherit';
        }
      },
      [theme.breakpoints.up(1024)]: {
        fontSize: theme.typography.pxToRem(16),
        height: 48
      }
    },
    body: _objectSpread(_objectSpread({}, theme.typography.body), {}, {
      backgroundColor: function (props) {
        return props.sorted ? '#f3f6f7' : 'inherit';
      },
      borderBottomColor: function (props) {
        return props.dividers ? theme.palette.divider : 'transparent';
      },
      [theme.breakpoints.up(1024)]: {
        paddingBottom: 18,
        paddingTop: 18
      },
      // row selected
      '.Mui-selected &': {
        backgroundColor: function (props) {
          return props.sorted ? '#cfdbe4' : '#dae3ec';
        }
      },
      // row hover
      '.pds-table__row:hover &': {
        backgroundColor: function (props) {
          return props.sorted ? '#abc0d2' : theme.palette.denim[100];
        }
      }
    }),
    paddingCheckbox: {
      paddingTop: 0,
      paddingBottom: 0
    }
  };
}, {
  name: 'pds-table__cell'
});